import { graphql } from "../generated";

// No @authenticated field: the /series/$series loader runs this before boot
// holds a token, exactly like GetShow. Progression and bookmark state come
// from components (GetSeriesProgression, useBookmark).
export const GET_SERIES_DETAILS = graphql(`
  query GetSeriesDetails($showId: ID!) {
    show(id: $showId) {
      id
      title
      displayTitle
      displayDescription
      displayTags
      # The raw tags, index-aligned with displayTags: each tag links to its
      # theme page, whose slug is the raw tag's (stable across locales).
      tags
      displayImage {
        original
      }
      displayThumbnail {
        original
      }
      displayHorizontalThumbnail {
        original
      }
      displayTitleImage {
        original
      }
      mostTrendingRank
      views
      episodesCount
      publishedAt
      createdAt
      unlisted
      actors {
        id
        fullName
        showsCount
        image {
          original
        }
      }
      episodes {
        id
        number
        length
        free
        url
        hasTimelineThumbnails
      }
    }
  }
`);
